import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCursor = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.0369 4.68802C3.99743 4.59694 3.98626 4.49609 4.00484 4.39858C4.02342 4.30107 4.07088 4.21139 4.14108 4.1412C4.21127 4.07101 4.30094 4.02354 4.39846 4.00496C4.49597 3.98638 4.59682 3.99755 4.6879 4.03702L20.6879 10.537C20.7852 10.5767 20.8675 10.6459 20.9232 10.735C20.9789 10.8241 21.0051 10.9284 20.9981 11.0333C20.9912 11.1381 20.9514 11.238 20.8844 11.319C20.8174 11.3999 20.7266 11.4576 20.6249 11.484L14.5009 13.064C14.1549 13.153 13.839 13.333 13.5861 13.5853C13.3332 13.8377 13.1526 14.1532 13.0629 14.499L11.4839 20.625C11.4575 20.7267 11.3997 20.8175 11.3188 20.8845C11.2379 20.9515 11.138 20.9913 11.0331 20.9983C10.9283 21.0052 10.824 20.979 10.7349 20.9233C10.6458 20.8676 10.5765 20.7853 10.5369 20.688L4.0369 4.68802Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCursor);
export { ForwardRef as ReactComponent };
